<main>
  <section class="hero-section">
    <div class="hero-text-container">
      <h1 class="especial-text">
        <span class="linha-titulo">
          <span class="text-first">Quanto</span>
          <span class="text-second">custa uma</span>
        </span>
        <span class="linha-titulo">
          <span class="text-third">educação</span>
          <span class="text-fourth">pública</span>
        </span>
        <span class="linha-titulo">
          <span class="text-fifth">de qualidade?</span>
        </span>
      </h1>

      <div class="relatorios-list">
        <a routerLink="/planejamento-orcamentario-apresentacao" class="btn-relatorio btn-relatorio-r1">
          <span>Orçamento para garantia de um padrão de qualidade</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a routerLink="/financiamento-atual-necessario" class="btn-relatorio btn-relatorio-r2">
          <span>Financiamento atual e necessário por <strong>ente federativo</strong></span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a routerLink="/custo-por-escola-apresentacao" class="btn-relatorio btn-relatorio-r3">
          <span>Custo das condições de qualidade por <strong>escola</strong></span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a routerLink="/caq-apresentacao" class="btn-relatorio btn-relatorio-r4">
          <span>Custo Aluno Qualidade por <strong>etapa/modalidade</strong></span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a *ngIf="featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')"
           routerLink="/relatorio-receitas-despesas-apresentacao"
           class="btn-relatorio btn-relatorio-r5">
          <span>Receitas e Despesas da educação básica</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <button *ngIf="!featureFlagService.funcionalidadeHabilitada('885-tela-apresentacao-relatorio-receitas-despesas')"
                disabled
                class="btn-relatorio btn-relatorio-disabled">
          <span>Receitas e Despesas da educação básica</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </button>
      </div>
    </div>

    <div class="hero-image-container">
      <img class="img-circles" src="assets/ilustrations/circles-background-1.png" alt="">
      <img class="hero-image" src="assets/imagens/children-teacher-book.png" alt="Quanto custa uma educação pública de qualidade">
    </div>
  </section>

  <section class="entenda-pqr-section">
    <div class="entenda-pqr-imagens">
      <img class="circulos-fundo-pqr" src="assets/ilustrations/circles-background-2.png" alt="">
      <img class="imagem-frente" src="assets/imagens/children-teacher.png" alt="Crianças em sala de aula">
    </div>

    <div class="entenda-pqr-texto">
      <h2 class="titulo-secao text-charcoal-600">
        Entenda o Padrão de<br>Qualidade de Referência (PQR)
      </h2>

      <div class="pqr-buttons-list">
        <a style="text-decoration: none !important;" href="/assets/20260903_PQR_alterado.remuneracao_VF.pdf" target="_blank" class="btn-relatorio btn-pqr-azul">
          <span>Dimensões e justificativas</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a routerLink="/pqr" class="btn-relatorio btn-pqr-vermelho">
          <span>Parâmetros para o cálculo do CAQ</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>

        <a routerLink="/qualidade" class="btn-relatorio btn-pqr-laranja">
          <span>Concepção de educação de qualidade</span>
          <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
        </a>
      </div>
    </div>
  </section>

  <section class="entenda-metodologia-section">
    <div class="entenda-metodologia-texto">
      <h2 class="titulo-secao text-charcoal-600">
        Entenda os cálculos<br>do simulador
      </h2>

      <a style="text-decoration: none !important;" href="/assets/20260904_SimCAQ_Aspectos_Metodologicos_SET2026_VFinal.pdf" target="_blank"
         class="btn-relatorio btn-metodologia">
        <span>Metodologia</span>
        <img src="assets/icons/arrow-right.svg" alt="" class="arrow-icon" width="20" height="20">
      </a>
    </div>

    <div class="entenda-metodologia-imagens">
      <img class="circulos-fundo-metodologia" src="assets/ilustrations/circles-background-3.png" alt="">
      <img class="imagem-frente" src="assets/imagens/granny.png" alt="Idosa em atividade educativa">
    </div>
  </section>

  <section class="tutorial-section">
    <div class="tutorial-video">
      <iframe
        class="tutorial-iframe"
        src="https://www.youtube.com/embed/sxlP6uyLYEA"
        title="Tutorial SimCAQ"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerpolicy="strict-origin-when-cross-origin"
        loading="lazy"
        allowfullscreen></iframe>
    </div>

    <div class="tutorial-texto">
      <h2 class="tutorial-titulo text-display-lg text-bold text-red-500">
        Tutorial SimCAQ
      </h2>
      <p class="tutorial-subtitulo text-heading-lg text-regular text-charcoal-600">
        Conheça a plataforma e entenda o seu funcionamento.
      </p>
    </div>
  </section>
</main>
